export class UpdateMealDateEntity {
  startAt?: string
  lockAt?: string
  companyPeriodTime?: string
}
